"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = addSource;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _addlistener = _interopRequireDefault(require("../on/_addlistener"));

var _addtreelistener = _interopRequireDefault(require("../on/_addtreelistener"));

var _seempleerror = _interopRequireDefault(require("../_helpers/seempleerror"));

// adds a source to a source list and adds needed event listener to a it
function addSource(_ref) {
  var calcHandler = _ref.calcHandler,
      allSources = _ref.allSources,
      sourceKey = _ref.sourceKey,
      sourceObject = _ref.sourceObject,
      eventOptions = _ref.eventOptions;
  var _eventOptions$exactKe = eventOptions.exactKey,
      exactKey = _eventOptions$exactKe === void 0 ? false : _eventOptions$exactKe;
  var isDelegated = false; // source key must be a string

  if (typeof sourceKey !== 'string') {
    throw (0, _seempleerror["default"])('calc:source_key_type', {
      sourceKey: sourceKey
    });
  } // source object must be an object


  if (!sourceObject || (0, _typeof2["default"])(sourceObject) !== 'object') {
    throw (0, _seempleerror["default"])('calc:source_object_type', {
      sourceObject: sourceObject
    });
  }

  if (!exactKey) {
    var deepPath = sourceKey.split('.'); // if something like a.b.c is used as a key

    if (deepPath.length > 1) {
      isDelegated = true; // TODO: Avoid collisions with bindings by using another event name
      // ... instead of _change:tree:xxx

      (0, _addtreelistener["default"])(sourceObject, deepPath, calcHandler);
    } else {
      exactKey = true;
    }
  }

  if (exactKey) {
    // normal handler
    (0, _addlistener["default"])(sourceObject, "_change:deps:".concat(sourceKey), calcHandler);
  }

  allSources.push({
    sourceKey: sourceKey,
    sourceObject: sourceObject,
    isDelegated: isDelegated
  });
}
//# sourceMappingURL=_addsource.js.map